export const FOBIcon = ({
  color = "#0F2C52",
  size = 24,
}: {
  color?: string;
  size?: number;
}) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ marginLeft: 3, marginBottom: 3 }}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1481_3364)">
        <path
          d="M9.5625 13.0238V17.4375H0.5625V11.8125L5.0625 8.4375L5.625 9.0105"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1875 0.562511C11.2519 0.561037 10.3329 0.810015 9.52602 1.2836C8.71911 1.75718 8.05367 2.4381 7.59877 3.25569C7.14387 4.07327 6.91609 4.99771 6.93908 5.93304C6.96207 6.86838 7.23498 7.78051 7.7295 8.57476L6.1875 11.8125L9.42525 10.2705C10.1156 10.6999 10.8963 10.9631 11.7057 11.0394C12.5151 11.1156 13.3312 11.0028 14.0896 10.7099C14.848 10.417 15.528 9.95194 16.0761 9.3514C16.6241 8.75086 17.0252 8.03125 17.2477 7.24927C17.4702 6.4673 17.508 5.64434 17.3582 4.84524C17.2084 4.04615 16.8751 3.29277 16.3845 2.64446C15.8939 1.99616 15.2594 1.47065 14.5311 1.10936C13.8028 0.748073 13.0005 0.560871 12.1875 0.562511Z"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.2185 3.375H11.6938C11.4601 3.37516 11.2338 3.45663 11.0536 3.60542C10.8734 3.75422 10.7506 3.96107 10.7063 4.1905C10.6619 4.41993 10.6988 4.65765 10.8106 4.86287C10.9223 5.06808 11.102 5.22802 11.3188 5.31525L12.8668 5.93475C13.0836 6.02198 13.2633 6.18192 13.375 6.38713C13.4868 6.59235 13.5236 6.83006 13.4793 7.0595C13.435 7.28893 13.3122 7.49578 13.132 7.64458C12.9518 7.79337 12.7255 7.87484 12.4918 7.875H10.9685"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0938 3.375V2.8125"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0938 8.4375V7.875"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1481_3364">
          <rect width="18" height="18" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};
